<div #formlyFormContainer>
    <ng-container *ngIf="!standalone">
        <div class="absolute inset-0 flex flex-col overflow-hidden" *transloco="let t">
            <div class="flex flex-row w-full items-center place-content-between pl-4 pr-2 pt-2 pb-4">
                <span class="font-bold">Visualizar formulário</span>
                <button mat-icon-button (click)="close()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>

            <div class="flex-grow w-full px-4 overflow-y-auto mat-typography" *ngIf="formViewModel">
                <div class="flex flex-col mb-6 space-y-2">
                    <div class="text-title">{{ formViewModel.title }}</div>

                    <div class="text-hint">{{ formViewModel.description }}</div>
                </div>

                <formly-form [model]="model" [fields]="fields" [options]="options" [form]="form"></formly-form>
            </div>
        </div>
    </ng-container>

    <formly-form [model]="model" [fields]="fields" [options]="options" [form]="form" *ngIf="standalone"></formly-form>
</div>
